<style scoped>
.newBox {
  height: 1.4rem;
  width: 7.5rem;
  padding: 0.24rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  color: #333;
  font-size: 0.36rem;
  background: #fafafa;
  z-index: 10;
  /*border-bottom: .01rem solid #D2D2D2;*/
}
.logo {
  /*position: absolute;
  left: 0.2rem;*/
  width: 100px;
  /*height: 1.4rem;*/
}
.close {
  width: 0.34rem;
  height: 0.34rem;
}
.close.active {
  background: url("~assets/close.png") no-repeat center/cover;
}
.news {
  width: 0.5rem;
  height: 0.4rem;
  background: url("~assets/news.png") no-repeat center/cover;
  position: relative;
}
.num {
  position: absolute;
  top: -0.08rem;
  right: -0.08rem;
  width: 0.22rem;
  height: 0.22rem;
  background: #e60012;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.12rem;
  color: #fff;
  border-radius: 50%;
}
</style>

<template>
  <div class="newBox">
    <div class="close" :class="{ active: status }" @click="close()"></div>
    <!--{{ title }}-->
    <img class="logo" src="../assets/common/logo.png" />
    <div class="news" @click="to(`news`)">
      <div class="num" v-if="count > 0">{{ count }}</div>
    </div>
  </div>
</template>

<script>
import { getSources } from "../api";

export default {
  props: ["title"],
  data() {
    return {
      count: 0,
      status: true,
      companyId: localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "",
    };
  },
  methods: {
    close() {
      var ua = navigator.userAgent;
      var isIos = /iPhone/i.test(ua);
      var isAndroid = /Android/i.test(ua);
      isIos &&
        window.webkit.messageHandlers.tellAppData.postMessage("backbackback");
      isAndroid && obj.tellAppData("backbackback");
    },
    to(n) {
      this.$router.push(`/${n}`);
    },

    async getNoReadCountForUser() {
      let data = await getSources(
        "/bear-scale/api/systemMessage/getNoReadCountForUser.json",
        {
          userId: localStorage.getItem("userId")
            ? localStorage.getItem("userId")
            : "",
        }
      );
      if (data.status === 0) {
        this.count = data.count;
      } else if (data.status === -1) {
        alert(data.msg);
        localStorage.clear();
        if (!localStorage.getItem("userId")) {
          this.$router.push(`/login`);
        } else {
          setTimeout(() => {
            this.$router.push(`/login`);
          }, 200);
        }
      }
    },
  },
  mounted() {
    // alert(localStorage.getItem('companyId'))
    if (localStorage.getItem("companyId") != "10015") {
      this.status = false;
    }

    this.getNoReadCountForUser();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/newsTopBox.vue?230b18ec